// extracted by mini-css-extract-plugin
module.exports = {"cardBodyWrapper":"DocumentCard-module--cardBodyWrapper--Qqmsj","cardScale":"DocumentCard-module--cardScale--2KhwD"};